// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__2Dz9g","choiceBoxes":"toolbarselects_choiceBoxes__1613n","simpleField":"toolbarselects_simpleField__1g5ar"};